import { subscribe, subscribePrelaunch } from './helpers';

export default Object.freeze({
    /**
     * @param {string}} email
     * @param {string} zip
     * @return {Promise}
     */
    subscribe({ email, zip }) {
        return subscribe({ email, zip });
    },
    /**
     * @param {string} email
     * @param {string} zip
     * @return {Promise}
     */
    subscribePrelaunch({ email, zip }) {
        return subscribePrelaunch({ email, zip });
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/subscription/actions.js